<template>
  <b-card :disabled="!link" no-body :class="{'reviewed-area-card': link}" @click="$event => onViewAreaReviews($event, link)">
    <div class="card-body">
      <span class="card-title text-capitalize">
        {{ title }}
      </span>

      <div class="card-sub-title mt-1 d-flex flex-column align-items-start">
        <div v-for="(review) in reviews" :key="review.id" class="w-100">
          <label for="review">{{ review.label }}</label>
          <b-form-rating
            v-if="review.type === 'rating'"
            id="review"
            v-model="review.answer"
            :max="5"
            :precision="1"
            :readonly="true"
            variant="warning"
            class="d-inline-block"
          />

          <b-form-textarea 
            v-if="review.type === 'text'"
            id="review"
            v-model="review.answer"
            :readonly="true"
            :no-resize="true"
          />
        </div>

        <div v-if="subTitle" class="w-100 text-right mt-1">
          <small>{{ subTitle }}</small>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { BCard, BFormRating, BFormTextarea } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BFormRating,
    BFormTextarea
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    reviews: {
      type: Array,
      required: true,
    },
    link: {
      type: String,
      default: null,
    },
    subTitle: {
      type: String,
      default: null,
    }
  },
  methods: {
    onViewAreaReviews(event, id) {
      this.$emit('view-area-reviews', event, id)
    }
  },
}
</script>

<style scoped>
  .reviewed-area-card {
    cursor: pointer;
    transition: box-shadow 0.3s ease-in-out;
  }

  .reviewed-area-card:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  }
</style>